// Otomax Fitment Gallery Dynamic Engine with Compact Display Formatting
const filterState = {
  activeMode: "vehicle",
  vehicle: { make: "", model: "", wheelBrand: "", tireBrand: "" },
  ring: { value: "", scope: "all", wheelBrand: "", tireBrand: "" },
  pcd: { value: "", scope: "all", ring: "", wheelBrand: "" }
};

let otxCardsDataset = [];

function otxNormalize(str) {
  if (!str) return "";
  return str.toString().toLowerCase().trim()
    .replace(/[—–-]/g, ' ').replace(/\s+/g, ' ')
    .replace(/5\s*[×x*]\s*114\.3/g, '5x114.3')
    .replace(/6\s*[×x*]\s*139\.7/g, '6x139.7')
    .replace(/5\s*[×x*]\s*139\.7/g, '5x139.7')
    .replace(/4\s*[×x*]\s*100/g, '4x100')
    .replace(/5\s*[×x*]\s*112/g, '5x112')
    .replace(/ring\s*([0-9]{2})/g, 'r$1');
}

function scanLiveProductsDataset() {
  const cardEls = document.querySelectorAll(".otx-fitment-card-link");
  otxCardsDataset = [];

  cardEls.forEach(card => {
    const merk = otxNormalize(card.getAttribute("data-merk") || "");
    const model = otxNormalize(card.getAttribute("data-model") || "");
    const velg = otxNormalize(card.getAttribute("data-velg") || "");
    const ban = otxNormalize(card.getAttribute("data-ban") || "");
    const ring = otxNormalize(card.getAttribute("data-ring") || "");
    const pcd = otxNormalize(card.getAttribute("data-pcd") || "");
    const txt = otxNormalize(card.textContent || "");

    otxCardsDataset.push({ el: card, merk, model, velg, ban, ring, pcd, txt });
  });
}

function getRingSourceItems() {
  if (filterState.ring.scope === "vehicle" && filterState.vehicle.make) {
    return otxCardsDataset.filter(item => {
      const makeMatch = item.merk === filterState.vehicle.make || item.txt.includes(filterState.vehicle.make);
      const modelMatch = !filterState.vehicle.model || item.model === filterState.vehicle.model || item.txt.includes(filterState.vehicle.model);
      return makeMatch && modelMatch;
    });
  }
  return otxCardsDataset;
}

function getPCDSourceItems() {
  if (filterState.pcd.scope === "vehicle" && filterState.vehicle.make) {
    return otxCardsDataset.filter(item => {
      const makeMatch = item.merk === filterState.vehicle.make || item.txt.includes(filterState.vehicle.make);
      const modelMatch = !filterState.vehicle.model || item.model === filterState.vehicle.model || item.txt.includes(filterState.vehicle.model);
      return makeMatch && modelMatch;
    });
  }
  return otxCardsDataset;
}

function rebuildCascadingDropdowns() {
  const currentMake = filterState.vehicle.make;
  const currentModel = filterState.vehicle.model;
  const currentVelg = filterState.vehicle.wheelBrand;
  const currentBan = filterState.vehicle.tireBrand;

  // A. Build Make Counts
  const makeCounts = {};
  otxCardsDataset.forEach(item => {
    if (item.merk && item.merk !== "lainnya") {
      makeCounts[item.merk] = (makeCounts[item.merk] || 0) + 1;
    }
  });

  const selectMerk = document.getElementById("otx-select-merk");
  if (selectMerk) {
    selectMerk.innerHTML = '<option value="">Semua Merk Kendaraan</option>';
    Object.keys(makeCounts).sort().forEach(m => {
      const opt = document.createElement("option");
      opt.value = m;
      opt.textContent = `${m.toUpperCase()} (${makeCounts[m]})`;
      if (m === currentMake) opt.selected = true;
      selectMerk.appendChild(opt);
    });
  }

  // B. Build Model Counts
  const selectTipe = document.getElementById("otx-select-tipe");
  if (selectTipe) {
    if (!currentMake) {
      selectTipe.disabled = true;
      selectTipe.innerHTML = '<option value="">Semua Tipe Kendaraan</option>';
      filterState.vehicle.model = "";
    } else {
      selectTipe.disabled = false;
      const modelCounts = {};
      otxCardsDataset.forEach(item => {
        if (item.merk === currentMake && item.model && item.model !== "lainnya") {
          modelCounts[item.model] = (modelCounts[item.model] || 0) + 1;
        }
      });

      selectTipe.innerHTML = '<option value="">Semua Tipe Kendaraan</option>';
      let isCurrentModelValid = false;
      Object.keys(modelCounts).sort().forEach(mod => {
        const opt = document.createElement("option");
        opt.value = mod;
        opt.textContent = `${mod.toUpperCase()} (${modelCounts[mod]})`;
        if (mod === currentModel) {
          opt.selected = true;
          isCurrentModelValid = true;
        }
        selectTipe.appendChild(opt);
      });

      if (currentModel && !isCurrentModelValid) {
        filterState.vehicle.model = "";
      }
    }
  }

  // C. Build Wheel Brand Counts
  const selectVelg = document.getElementById("otx-select-velg");
  if (selectVelg) {
    const velgCounts = {};
    otxCardsDataset.forEach(item => {
      let match = true;
      if (currentMake && item.merk !== currentMake) match = false;
      if (filterState.vehicle.model && item.model !== filterState.vehicle.model) match = false;
      if (match && item.velg && item.velg !== "otomax") {
        velgCounts[item.velg] = (velgCounts[item.velg] || 0) + 1;
      }
    });

    selectVelg.innerHTML = '<option value="">Semua Brand Velg</option>';
    let isCurrentVelgValid = false;
    Object.keys(velgCounts).sort().forEach(v => {
      const opt = document.createElement("option");
      opt.value = v;
      opt.textContent = `${v.toUpperCase()} (${velgCounts[v]})`;
      if (v === currentVelg) {
        opt.selected = true;
        isCurrentVelgValid = true;
      }
      selectVelg.appendChild(opt);
    });

    if (currentVelg && !isCurrentVelgValid) {
      filterState.vehicle.wheelBrand = "";
    }
  }

  // D. Build Tire Brand Counts
  const selectBan = document.getElementById("otx-select-ban");
  if (selectBan) {
    const banCounts = {};
    otxCardsDataset.forEach(item => {
      let match = true;
      if (currentMake && item.merk !== currentMake) match = false;
      if (filterState.vehicle.model && item.model !== filterState.vehicle.model) match = false;
      if (filterState.vehicle.wheelBrand && item.velg !== filterState.vehicle.wheelBrand) match = false;
      if (match && item.ban && item.ban !== "otomax") {
        banCounts[item.ban] = (banCounts[item.ban] || 0) + 1;
      }
    });

    selectBan.innerHTML = '<option value="">Semua Brand Ban</option>';
    let isCurrentBanValid = false;
    Object.keys(banCounts).sort().forEach(b => {
      const opt = document.createElement("option");
      opt.value = b;
      opt.textContent = `${b.toUpperCase()} (${banCounts[b]})`;
      if (b === currentBan) {
        opt.selected = true;
        isCurrentBanValid = true;
      }
      selectBan.appendChild(opt);
    });

    if (currentBan && !isCurrentBanValid) {
      filterState.vehicle.tireBrand = "";
    }
  }

  rebuildRingOptions();
  rebuildPCDOptions();
}

function rebuildRingOptions() {
  const ringContainer = document.getElementById("otx-pills-ring-container");
  if (!ringContainer) return;

  const sourceItems = getRingSourceItems();
  const ringCounts = {};
  sourceItems.forEach(item => {
    if (item.ring) ringCounts[item.ring] = (ringCounts[item.ring] || 0) + 1;
  });

  const availableRings = Object.keys(ringCounts).sort((a, b) => parseInt(a.replace('r','')) - parseInt(b.replace('r','')));

  if (filterState.ring.value && !availableRings.includes(filterState.ring.value)) {
    filterState.ring.value = "";
  }

  ringContainer.innerHTML = '';

  const defaultBtn = document.createElement("button");
  defaultBtn.type = "button";
  defaultBtn.className = `otx-fitment-pill ${!filterState.ring.value ? 'active' : ''}`;
  defaultBtn.setAttribute("data-ring-val", "");
  defaultBtn.textContent = "Semua";
  defaultBtn.addEventListener("click", function() {
    document.querySelectorAll("#otx-pills-ring-container .otx-fitment-pill").forEach(p => p.classList.remove("active"));
    this.classList.add("active");
    filterState.ring.value = "";
    applyOtFitmentFilter();
  });
  ringContainer.appendChild(defaultBtn);

  availableRings.forEach(r => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `otx-fitment-pill ${r === filterState.ring.value ? 'active' : ''}`;
    btn.setAttribute("data-ring-val", r);
    btn.textContent = `R${r.replace('r','').toUpperCase()}`;
    btn.addEventListener("click", function() {
      document.querySelectorAll("#otx-pills-ring-container .otx-fitment-pill").forEach(p => p.classList.remove("active"));
      this.classList.add("active");
      filterState.ring.value = r;
      applyOtFitmentFilter();
    });
    ringContainer.appendChild(btn);
  });
}

function formatPCDDisplay(rawPcd) {
  if (!rawPcd) return "";
  let clean = rawPcd.toLowerCase().replace('pcd', '').trim();
  return clean.replace('x', '×').toUpperCase();
}

function rebuildPCDOptions() {
  const pcdContainer = document.getElementById("otx-pills-pcd-container");
  if (!pcdContainer) return;

  const sourceItems = getPCDSourceItems();
  const pcdCounts = {};
  sourceItems.forEach(item => {
    if (item.pcd) pcdCounts[item.pcd] = (pcdCounts[item.pcd] || 0) + 1;
  });

  const availablePCDs = Object.keys(pcdCounts).sort();

  if (filterState.pcd.value && !availablePCDs.includes(filterState.pcd.value)) {
    filterState.pcd.value = "";
  }

  pcdContainer.innerHTML = '';

  const defaultBtn = document.createElement("button");
  defaultBtn.type = "button";
  defaultBtn.className = `otx-fitment-pill ${!filterState.pcd.value ? 'active' : ''}`;
  defaultBtn.setAttribute("data-pcd-val", "");
  defaultBtn.textContent = "Semua";
  defaultBtn.addEventListener("click", function() {
    document.querySelectorAll("#otx-pills-pcd-container .otx-fitment-pill").forEach(p => p.classList.remove("active"));
    this.classList.add("active");
    filterState.pcd.value = "";
    applyOtFitmentFilter();
  });
  pcdContainer.appendChild(defaultBtn);

  availablePCDs.forEach(p => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `otx-fitment-pill ${p === filterState.pcd.value ? 'active' : ''}`;
    btn.setAttribute("data-pcd-val", p);
    btn.textContent = formatPCDDisplay(p);
    btn.addEventListener("click", function() {
      document.querySelectorAll("#otx-pills-pcd-container .otx-fitment-pill").forEach(p => p.classList.remove("active"));
      this.classList.add("active");
      filterState.pcd.value = p;
      applyOtFitmentFilter();
    });
    pcdContainer.appendChild(btn);
  });
}

function updateURLState() {
  const params = new URLSearchParams(window.location.search);
  const fitmentKeys = ['mode', 'make', 'model', 'wheel_brand', 'tire_brand', 'ring', 'pcd', 'scope'];
  fitmentKeys.forEach(k => params.delete(k));

  params.set('mode', filterState.activeMode);

  if (filterState.activeMode === 'vehicle') {
    if (filterState.vehicle.make) params.set('make', filterState.vehicle.make);
    if (filterState.vehicle.model) params.set('model', filterState.vehicle.model);
    if (filterState.vehicle.wheelBrand) params.set('wheel_brand', filterState.vehicle.wheelBrand);
    if (filterState.vehicle.tireBrand) params.set('tire_brand', filterState.vehicle.tireBrand);
  } else if (filterState.activeMode === 'ring') {
    if (filterState.ring.value) params.set('ring', filterState.ring.value);
    params.set('scope', filterState.ring.scope);
    if (filterState.ring.scope === 'vehicle' && filterState.vehicle.make) {
      params.set('make', filterState.vehicle.make);
      if (filterState.vehicle.model) params.set('model', filterState.vehicle.model);
    }
  } else if (filterState.activeMode === 'pcd') {
    if (filterState.pcd.value) params.set('pcd', filterState.pcd.value);
    params.set('scope', filterState.pcd.scope);
    if (filterState.pcd.scope === 'vehicle' && filterState.vehicle.make) {
      params.set('make', filterState.vehicle.make);
      if (filterState.vehicle.model) params.set('model', filterState.vehicle.model);
    }
  }

  const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  window.history.replaceState({ path: newUrl }, '', newUrl);
}

function renderActiveChips() {
  const chipsBar = document.getElementById("otx-active-chips-bar");
  const chipsList = document.getElementById("otx-chips-list");
  if (!chipsBar || !chipsList) return;

  chipsList.innerHTML = "";
  const chips = [];

  if (filterState.activeMode === 'vehicle') {
    if (filterState.vehicle.make) chips.push(filterState.vehicle.make.toUpperCase());
    if (filterState.vehicle.model) chips.push(filterState.vehicle.model.toUpperCase());
    if (filterState.vehicle.wheelBrand) chips.push(filterState.vehicle.wheelBrand.toUpperCase());
  } else if (filterState.activeMode === 'ring') {
    if (filterState.ring.value) chips.push("R" + filterState.ring.value.replace('r','').toUpperCase());
    if (filterState.ring.scope === 'vehicle' && filterState.vehicle.make) {
      chips.push(filterState.vehicle.make.toUpperCase() + (filterState.vehicle.model ? " " + filterState.vehicle.model.toUpperCase() : ""));
      chips.push("Sesuai Kendaraan");
    } else {
      chips.push("Semua Kendaraan");
    }
  } else if (filterState.activeMode === 'pcd') {
    if (filterState.pcd.value) chips.push(formatPCDDisplay(filterState.pcd.value));
    if (filterState.pcd.scope === 'vehicle' && filterState.vehicle.make) {
      chips.push(filterState.vehicle.make.toUpperCase() + (filterState.vehicle.model ? " " + filterState.vehicle.model.toUpperCase() : ""));
      chips.push("Sesuai Kendaraan");
    } else {
      chips.push("Semua Kendaraan");
    }
  }

  if (chips.length > 0) {
    chipsBar.style.display = "flex";
    chips.forEach(c => {
      const span = document.createElement("span");
      span.className = "otx-chip";
      span.textContent = c;
      chipsList.appendChild(span);
    });
  } else {
    chipsBar.style.display = "none";
  }
}

function updateVehicleUI() {
  const vehicleNameText = (filterState.vehicle.make ? filterState.vehicle.make.toUpperCase() : "") + (filterState.vehicle.model ? " " + filterState.vehicle.model.toUpperCase() : "");

  ['ring', 'pcd'].forEach(tab => {
    const summaryCard = document.getElementById(`otx-${tab}-vehicle-summary`);
    const summaryName = document.getElementById(`otx-${tab}-vehicle-name`);
    const scopeBox = document.getElementById(`otx-${tab}-scope-wrapper`);

    if (filterState.vehicle.make) {
      if (summaryCard) summaryCard.style.display = "flex";
      if (summaryName) summaryName.textContent = vehicleNameText;
      if (scopeBox) scopeBox.style.display = "flex";
    } else {
      if (summaryCard) summaryCard.style.display = "none";
      if (scopeBox) scopeBox.style.display = "none";
    }
  });
}

function applyOtFitmentFilter() {
  rebuildCascadingDropdowns();
  updateVehicleUI();

  const countTitle = document.querySelector(".otx-gallery-count-title");
  let visibleCount = 0;

  otxCardsDataset.forEach(item => {
    let match = true;

    if (filterState.activeMode === "vehicle") {
      if (filterState.vehicle.make && !item.merk.includes(filterState.vehicle.make) && !item.txt.includes(filterState.vehicle.make)) match = false;
      if (filterState.vehicle.model && !item.model.includes(filterState.vehicle.model) && !item.txt.includes(filterState.vehicle.model)) match = false;
      if (filterState.vehicle.wheelBrand && !item.velg.includes(filterState.vehicle.wheelBrand) && !item.txt.includes(filterState.vehicle.wheelBrand)) match = false;
      if (filterState.vehicle.tireBrand && !item.ban.includes(filterState.vehicle.tireBrand) && !item.txt.includes(filterState.vehicle.tireBrand)) match = false;
    } else if (filterState.activeMode === "ring") {
      if (filterState.ring.value && !item.ring.includes(filterState.ring.value) && !item.txt.includes(filterState.ring.value) && !item.ring.includes(filterState.ring.value.replace('r',''))) match = false;
      if (filterState.ring.scope === "vehicle" && filterState.vehicle.make) {
        if (!item.merk.includes(filterState.vehicle.make) && !item.txt.includes(filterState.vehicle.make)) match = false;
        if (filterState.vehicle.model && !item.model.includes(filterState.vehicle.model) && !item.txt.includes(filterState.vehicle.model)) match = false;
      }
    } else if (filterState.activeMode === "pcd") {
      if (filterState.pcd.value && !item.pcd.includes(filterState.pcd.value) && !item.txt.includes(filterState.pcd.value)) match = false;
      if (filterState.pcd.scope === "vehicle" && filterState.vehicle.make) {
        if (!item.merk.includes(filterState.vehicle.make) && !item.txt.includes(filterState.vehicle.make)) match = false;
        if (filterState.vehicle.model && !item.model.includes(filterState.vehicle.model) && !item.txt.includes(filterState.vehicle.model)) match = false;
      }
    }

    if (match) {
      item.el.style.display = "block";
      visibleCount++;
    } else {
      item.el.style.display = "none";
    }
  });

  if (countTitle) {
    countTitle.textContent = visibleCount + " INSPIRASI FITMENT DITEMUKAN";
  }

  renderActiveChips();
  updateURLState();
}

function resetOtFitmentFilter() {
  filterState.activeMode = "vehicle";
  filterState.vehicle = { make: "", model: "", wheelBrand: "", tireBrand: "" };
  filterState.ring = { value: "", scope: "all", wheelBrand: "", tireBrand: "" };
  filterState.pcd = { value: "", scope: "all", ring: "", wheelBrand: "" };

  const selectMerk = document.getElementById("otx-select-merk");
  const selectTipe = document.getElementById("otx-select-tipe");
  const selectVelg = document.getElementById("otx-select-velg");
  const selectBan = document.getElementById("otx-select-ban");

  if (selectMerk) selectMerk.value = "";
  if (selectTipe) { selectTipe.value = ""; selectTipe.disabled = true; }
  if (selectVelg) selectVelg.value = "";
  if (selectBan) selectBan.value = "";

  const tabBtns = document.querySelectorAll(".otx-fitment-tab-btn");
  const tabSecs = document.querySelectorAll(".otx-fitment-tab-sec");
  tabBtns.forEach((b, idx) => b.classList.toggle("active", idx === 0));
  tabSecs.forEach((s, idx) => s.classList.toggle("active", idx === 0));

  applyOtFitmentFilter();
}

function bindFilterEvents() {
  document.querySelectorAll(".otx-fitment-tab-btn").forEach(btn => {
    btn.addEventListener("click", function() {
      const mode = this.getAttribute("data-tab-mode");
      if (mode) {
        filterState.activeMode = mode;
        document.querySelectorAll(".otx-fitment-tab-btn").forEach(b => b.classList.remove("active"));
        document.querySelectorAll(".otx-fitment-tab-sec").forEach(s => s.classList.remove("active"));
        this.classList.add("active");
        const sec = document.getElementById("otx-tab-sec-" + mode);
        if (sec) sec.classList.add("active");
        applyOtFitmentFilter();
      }
    });
  });

  const selectMerk = document.getElementById("otx-select-merk");
  if (selectMerk) {
    selectMerk.addEventListener("change", function() {
      filterState.vehicle.make = this.value;
      filterState.vehicle.model = "";
      applyOtFitmentFilter();
    });
  }

  const selectTipe = document.getElementById("otx-select-tipe");
  if (selectTipe) {
    selectTipe.addEventListener("change", function() {
      filterState.vehicle.model = this.value;
      applyOtFitmentFilter();
    });
  }

  const selectVelg = document.getElementById("otx-select-velg");
  if (selectVelg) {
    selectVelg.addEventListener("change", function() {
      filterState.vehicle.wheelBrand = this.value;
      applyOtFitmentFilter();
    });
  }

  const selectBan = document.getElementById("otx-select-ban");
  if (selectBan) {
    selectBan.addEventListener("change", function() {
      filterState.vehicle.tireBrand = this.value;
      applyOtFitmentFilter();
    });
  }

  ['ring', 'pcd'].forEach(tab => {
    document.querySelectorAll(`input[name="${tab}_scope_input"]`).forEach(radio => {
      radio.addEventListener("change", function() {
        filterState[tab].scope = this.value;
        applyOtFitmentFilter();
      });
    });
  });

  document.querySelectorAll('[data-action="clear-vehicle"]').forEach(btn => {
    btn.addEventListener("click", function() {
      filterState.vehicle.make = "";
      filterState.vehicle.model = "";
      const selectMerk = document.getElementById("otx-select-merk");
      if (selectMerk) selectMerk.value = "";
      applyOtFitmentFilter();
    });
  });

  const submitBtn = document.getElementById("otx-submit-btn-el");
  if (submitBtn) submitBtn.addEventListener("click", applyOtFitmentFilter);

  const resetBtn = document.getElementById("otx-reset-btn-el");
  if (resetBtn) resetBtn.addEventListener("click", resetOtFitmentFilter);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function() {
    scanLiveProductsDataset();
    bindFilterEvents();
    applyOtFitmentFilter();
  });
} else {
  scanLiveProductsDataset();
  bindFilterEvents();
  applyOtFitmentFilter();
}


// Isolated Pagination Extension
const otxGalleryPaging = {
  initial: 8,
  perLoad: 8,
  visible: 8
};

function otxEnsureLoadMoreButton() {
  let btn = document.getElementById("otx-fitment-load-more");
  if (!btn) {
    const grid = document.querySelector(".otx-fitment-cards-grid");
    if (grid) {
      const wrap = document.createElement("div");
      wrap.style.textAlign = "center";
      wrap.style.paddingTop = "24px";

      btn = document.createElement("button");
      btn.type = "button";
      btn.id = "otx-fitment-load-more";
      btn.className = "otx-fitment-submit-btn";
      btn.style.minWidth = "220px";
      btn.style.margin = "0 auto";
      btn.innerHTML = '<span>Muat Lebih Banyak</span>';
      btn.addEventListener("click", otxHandleLoadMoreClick);

      wrap.appendChild(btn);
      grid.insertAdjacentElement("afterend", wrap);
    }
  }
  return btn;
}

function otxHydrateImage(card) {
  const img = card.querySelector(".otx-fitment-card__img");
  if (img) {
    const dataSrc = img.getAttribute("data-src");
    if (dataSrc) {
      img.src = dataSrc;
      img.removeAttribute("data-src");
    }
  }
}

function otxApplyPagingLimit() {
  const cards = document.querySelectorAll(".otx-fitment-card-link");
  const matching = [];
  cards.forEach(card => {
    if (card.style.display !== "none") {
      matching.push(card);
    }
  });

  let shown = 0;
  matching.forEach((card, index) => {
    if (index < otxGalleryPaging.visible) {
      card.removeAttribute("hidden");
      card.removeAttribute("data-otx-page-hidden");
      otxHydrateImage(card);
      shown++;
    } else {
      card.setAttribute("hidden", "hidden");
      card.setAttribute("data-otx-page-hidden", "true");
    }
  });

  const countTitle = document.querySelector(".otx-gallery-count-title");
  const gallerySec = document.querySelector(".otx-fitment-gallery-sec");
  const totalLiveCount = (gallerySec && gallerySec.getAttribute("data-total-collection-count")) ? parseInt(gallerySec.getAttribute("data-total-collection-count")) : matching.length;
  
  if (countTitle) {
    const isFiltered = (typeof otxIsFilterActive === "function") ? otxIsFilterActive() : (matching.length < cards.length);
    const targetTotal = isFiltered ? matching.length : Math.max(totalLiveCount, matching.length);
    countTitle.textContent = `Menampilkan ${shown} dari ${targetTotal} inspirasi`;
  }

  const btn = otxEnsureLoadMoreButton();
  if (btn) {
    btn.disabled = false;
    btn.innerHTML = '<span>Muat Lebih Banyak</span>';
    if (shown >= matching.length) {
      btn.setAttribute("hidden", "hidden");
    } else {
      btn.removeAttribute("hidden");
    }
  }
}

function otxHandleLoadMoreClick() {
  const btn = document.getElementById("otx-fitment-load-more");
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<span>Memuat…</span>';
  }
  setTimeout(() => {
    otxGalleryPaging.visible += otxGalleryPaging.perLoad;
    otxApplyPagingLimit();
  }, 80);
}

// Hook onto existing filter completion & DOM load
const otxOriginalApplyFilter = applyOtFitmentFilter;
applyOtFitmentFilter = function() {
  otxOriginalApplyFilter();
  otxGalleryPaging.visible = otxGalleryPaging.initial;
  otxApplyPagingLimit();
};

document.addEventListener("DOMContentLoaded", function() {
  otxEnsureLoadMoreButton();
  otxGalleryPaging.visible = otxGalleryPaging.initial;
  otxApplyPagingLimit();
});
